// extracted by mini-css-extract-plugin
module.exports = {"mobile":"576px","tablet":"768px","desktop":"992px"};